import GuideCapitoliList from './GuideCapitoliList';

export default GuideCapitoliList;
